import { Col, Container, Row } from "react-bootstrap";
import "./Products.css";
import { useEffect, useState } from "react";
import ProductDetail from "../components/ProductDetail";

/**
 * @typedef {import('../model/ProductDetailModel').ProductDetailModel} ProductDetailModel
 * @typedef {import('../model/ProductModel').ProductModel} ProductModel
 */

const PRODUCTS_URL = `${process.env.PUBLIC_URL}/static/data/products.json`;

function Products() {
  const [showDetailComponent, setShowDetailComponent] = useState(false);
  const [productDetailPageTitle, setProductDetailPageTitle] = useState("");
  const [products, setProducts] = useState(
    /** @type {ProductModel | null} */ (null)
  );
  const [productDetails, setProductDetails] = useState(
    /** @type {ProductDetailModel[] | null} */ (null)
  );

  useEffect(() => {
    const fetchUrl = `${PRODUCTS_URL}?cb=${Date.now()}`; // unique query to defeat stale caches

    fetch(fetchUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      mode: "cors",
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setProducts(data);
      })
      .catch((error) => console.error("Error:", error));
  }, []);

  /**
   * @param {string} title
   */
  const onClickShowDetail = (title) => {
    setProductDetailPageTitle(title);
    setShowDetailComponent(true);
    switch (title) {
      case "Dondurmalar":
        if (products?.icecream) setProductDetails(products?.icecream);
        break;
      case "Yoğurtlar":
        if (products?.yogurts) setProductDetails(products?.yogurts);
        break;
      case "Külahlar":
        if (products?.cones) setProductDetails(products?.cones);
        break;
      case "İçecekler":
        if (products?.drinks) setProductDetails(products?.drinks);
        break;
      case "Tatlı":
        if (products?.dessert) setProductDetails(products?.dessert);
        break;
      default:
        setProductDetails(null);
    }
  };

  return (
    <>
      {showDetailComponent ? (
        productDetails ? (
          <ProductDetail
            productDetails={productDetails}
            pageTitle={productDetailPageTitle}
          />
        ) : null
      ) : (
        <div>
          <h1 style={{ margin: "30px 0px 90px 0px" }}>Ürünlerimiz</h1>
          <Container className="products-container">
            <Row>
              <Col>
                <img
                  className="img-pull-left-side"
                  onClick={() => {
                    onClickShowDetail("Dondurmalar");
                  }}
                  style={{ width: "30%" }}
                  src="https://boac-website.s3.eu-central-1.amazonaws.com/products_icecream_btn.png"
                  alt="Dondurmalar"
                />
                <h3 style={{ margin: "20px 0px 130px 0px" }}>Dondurmalar</h3>
              </Col>
              <Col>
                <img
                  className="img-pull-left-side"
                  onClick={() => {
                    onClickShowDetail("Yoğurtlar");
                  }}
                  style={{ width: "30%" }}
                  src="https://boac-website.s3.eu-central-1.amazonaws.com/products_yogurt_btn.png"
                  alt="Yoğurtlar"
                />
                <h3 style={{ margin: "20px 0px 130px 0px" }}>Yoğurtlar</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <img
                  className="img-pull-left-side"
                  style={{ width: "30%" }}
                  onClick={() => {
                    onClickShowDetail("Külahlar");
                  }}
                  src="https://boac-website.s3.eu-central-1.amazonaws.com/products_cone_btn.png"
                  alt="Külahlar"
                />
                <h3 style={{ margin: "20px 0px 130px 0px" }}>Külahlar</h3>
              </Col>
              <Col>
                <img
                  className="img-pull-left-side"
                  style={{ width: "15%" }}
                  onClick={() => {
                    onClickShowDetail("İçecekler");
                  }}
                  src="https://boac-website.s3.eu-central-1.amazonaws.com/products_drink_btn.png"
                  alt="İçecekler"
                />
                <h3 style={{ margin: "20px 0px 130px 0px" }}>İçecekler</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <img
                  className="img-pull-left-side"
                  onClick={() => {
                    onClickShowDetail("Tatlı");
                  }}
                  style={{ width: "40%" }}
                  src="https://boac-website.s3.eu-central-1.amazonaws.com/products_dessert_btn.png"
                  alt="Tatlılar"
                />
                <h3 style={{ margin: "20px 0px 130px 0px" }}>Tatlılar</h3>
              </Col>
              <Col></Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
}

export default Products;
